
<template>
    <v-dialog v-model="dialog" persistent :max-width="maxWidth">
      <template v-slot:activator="{ on }">
        <v-btn v-if="btnIcon==''"
          text
          :style="(btnIcon == '' && btnTxt == '') ? 'display: none' : ''"
          v-on="on"
          small
        >
          {{btnTxt}}<v-spacer></v-spacer>
        </v-btn>
        <v-btn v-else-if="btnTxt=='' && showText == true"
          :style="(btnIcon == '' && btnTxt == '') ? 'display: none' : ''"
          text
          v-on="on"
          small
          icon
        >
          <v-icon small>{{btnIcon}}</v-icon>
        </v-btn>
        <v-btn v-else-if="btnTxt==''"
          :style="(btnIcon == '' && btnTxt == '') ? 'display: none' : ''"
          text
          v-on="on"
          small
          icon
        >
          <v-icon x-small>{{btnIcon}}</v-icon>
        </v-btn>
        <v-btn v-else
          :style="(btnIcon == '' && btnTxt == '') ? 'display: none' : ''"
          text
          v-on="on"
          small
          icon
        >
          <v-icon x-small class="mr-3">{{btnIcon}}</v-icon>{{ showText ? btnTxt : ''}}<v-spacer></v-spacer>
        </v-btn>
      </template>
      <v-card class="v-card-custom-dialog">
        <v-card-title
          class="headline white--text"
          :class="color"
          primary-title>
          {{ getTitle() }}
        </v-card-title>
        <v-card-text>&nbsp;</v-card-text>
        <v-card-text v-if="info !== ''"><span class="font-bold text-lg" :class="textColor">{{ info }}</span></v-card-text>
        <v-card-text><span class="contentShow">{{ detail }}</span></v-card-text>
        <v-divider class="deviderColor"></v-divider>
        <v-card-actions class="btn-pos">
          <v-spacer></v-spacer>
          <v-btn class="btn-height-custom btnConfirm mb-0" @click="selectOk($event)">OK</v-btn>
          <v-btn v-if="showCancel" class="btn-height-custom mb-0 pa-0 btnCancel" @click="selectClose()">Cancel</v-btn>
          <!-- <v-btn class="btn-height-custom" @click="selectClose()">Close</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  export default {
    props: {
        title: {
            default: '',
        },
        info: {
            default: '',
        },
        detail: {
            default: '',
        },
        dataValue: {
            default: Object,
        },
        showCancel: {
          default: false,
        },
        showText: {
          default: true,
        },
        color: {
            default: 'validation',
            required: false,
            validator: value => {
              return ['success', 'error', 'warning', 'information', 'validation', 'confirmation'].includes(value);
            }
        },
        btnTxt: {
            default: ''
        },
        btnIcon: {
            default: ''
        },
        size: {
          default: 'min'
        }
    },
    data () {
      return {
        dialog: false,
      }
    },
    computed: {
      textColor() {
        return this.color + '--text';
      },
      maxWidth() {
        return this.size == 'min' ? 250 : 600;
      }
    },
    watch: {
      dialog () {
        // 팝업이 열리면 드랍다운 메뉴가 닫히지 않도록 close가 되지 않도록 하는 로직 추가
        // 팝업 컨텐츠를 드래그할 경우 팝업이 닫히는 문제를 해결하기 위해
        // 상위 컴포넌트에서 컴포넌트 선언 시 이 이벤트를 받지 않으면, 여기서 발생시킨 이벤트는 버려짐
        this.dialog ? this.$emit('disable-close') : this.$emit('enable-close');
      },
    },
    methods: {
      getTitle() {
        if (this.color == 'success') {
          return 'Success';
        } else if (this.color == 'alert') {
          return 'Alert';
        } else if (this.color == 'warning') {
          return 'Warning';
        } else if (this.color == 'error') {
          return 'Error';
        } else if (this.color == 'information') {
          return 'Information';
        } else if (this.color == 'confirmation') {
          return 'Confirmation';
        } else if (this.color.includes('validation')) {
          return 'Warning';
        } else {
          return this.title;
        }
      },
        selectOk() {
            this.$emit("select-ok", this.dataValue);
            this.dialog = false;
        },
        selectClose() {
          this.$emit("select-close", this.dataValue);
          this.dialog = false;
        }
    }
  }
</script>

<style scoped>
.v-card__title.headline.white--text.warning, .v-card__title.headline.white--text.validation{
  background-color: #E1B61E !important;
  font-family: Open Sans  !important;
  font-weight: bold  !important;
  font-size: 20px  !important;
  line-height: 34px  !important;
}
.v-card__title.headline.white--text.information, .v-card__title.headline.white--text.confirmation{
  background-color: #215A73 !important;
  font-family: Open Sans !important;
  font-style: normal;
  font-weight: bold !important;
  font-size: 20px !important;
  line-height: 34px !important;
}
.v-card__title.headline.white--text.success{
  background-color: #217346 !important;
  font-family: Open Sans !important;
  font-style: normal;
  font-weight: bold !important;
  font-size: 20px !important;
  line-height: 34px !important;
}
.v-card__title.headline.white--text.error{
  background-color: #CD5F5F !important;
  font-family: Open Sans !important;
  font-style: normal;
  font-weight: bold !important;
  font-size: 20px !important;
  line-height: 34px !important;
}
.btnConfirm{
  background-color: #0082BA !important;
  min-width: 55px !important;
}
.btnCancel{
  background-color: #CD5F5F !important;
  min-width: 55px !important;
  font-size: 12px;
}
.contentShow{
  font-family: Open Sans ;
  font-style: normal;
  font-weight: normal ;
  font-size: 14px ;
  line-height: 19px ;
  color: #12083F;
}
.deviderColor{
  border-color: #E5E5E5 !important;
}
.btn-pos{
  padding: 10px 20px 10px 10px;
}
.v-dialog .v-card .v-card__title{
   padding: 19px 10px 16px 21px;
}

.theme--light .v-card-custom-dialog {
  background-color: #DDDEE1;
}

.theme--light .deviderColor {
  border-color: #D1D3D8 !important;
}

.theme--light .v-card span.contentShow {
  color: #12083F;
}

.confirmation--text{
  color: #215A73 !important;
}

.theme--dark .v-card-custom-dialog {
  background: #292C35;
}

.theme--dark .deviderColor {
  background: #292C35;
}

.theme--dark .v-card span.contentShow {
  color: #bbbbbb;
}
</style>